import { client } from './client';
import { appConfig } from '../config/app-config';
import { ProductPermissions } from '../constants/constants';
import { User } from '../types/types';

export const getCurrentUser = (): Promise<User> =>
  client('users/current', { method: 'GET' }, appConfig.apiUrls.container, true);

export const getUserPermissions = (
  productType = 'RPDMANPO'
): Promise<ProductPermissions[]> =>
  client(
    `users/current/permissions/${productType}`,
    { method: 'GET' },
    appConfig.apiUrls.container,
    false
  );

export const getUserStores = () =>
  client(
    'users/current/stores?q=permissions[:includes]=RACPAD_DAP',
    { method: 'GET' },
    appConfig.apiUrls.container,
    false
  );

export const getPinDetails = async (Payload: any) => {
  return await client(
    `coworker`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.storemgmt,
    true
  );
};

export const getprofileaccess = async (Payload: any) => {
  return await client(
    `store-access`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.storemgmt,
    true
  );
};

export const getsecondfactor = async (Payload: any) => {
  return await client(
    `coworker-authentication`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.storemgmt,
    true
  );
};

export const GetRemoteLoginStatus = async (Payload: any) => {
  return await client(
    `cashmgmt/duo/auth`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.cashmgmt,
    true
  );
};
